<template>
  <section>
    <h3 class="step-one__header">Step 1: Upload a list of images</h3>
    <div class="step-one__flex">
      <div class="step-one__half">
        <p>Upload a csv file with images and metadata. A column containing urls will be interpreted as a column with images.</p>
        <p>Alternatively, choose one of our example dataset:</p>
        <select
          class="step-one__select"
          v-model="selectedDataset"
          @change="changeDataset()"
        >
          <option value></option>
          <option value="1">NIH chest x-rays</option>
        </select>
      </div>
      <div class="step-one__half">
        <input
          type="file"
          name="fileModal"
          id="fileModal"
          class="step-one__custom-input"
          @change="addFilebyClick"
        />
        <label
          for="fileModal"
          class="step-one__drag--error"
          v-if="csvError !== ''"
          @drop.prevent="addFile"
          @dragover.prevent
        >{{ csvError }}</label>
        <label
          for="fileModal"
          class="step-one__drag"
          v-else-if="!dropedFile"
          @drop.prevent="addFile"
          @dragover.prevent
        >Drag & drop a file or click here to select it</label>
        <label
          for="fileModal"
          class="step-one__drag"
          @drop.prevent="addFile"
          @dragover.prevent
          v-else
        >{{ dropedFile.name }}</label>
        <p class="step-one__nameText">Set a simple name of the study for easy access</p>
        <fg-input class="step-one__nameInput" name="studiesFile" :value="studyName" @change="onStudyNameChange"></fg-input>
      </div>
    </div>
  </section>
</template>

<script>
import axios from '../../axios'
  export default {
    name: 'page-two',
    data() {
      return {
        selectedDataset: "",
        fileInput: null,
      };
    },
    computed:{
      csvError() {
        return this.$store.getters.getCsvError;
      },
      csvHeaders() {
        return this.$store.getters.getCsvHeaders;
      },
      csvData() {
        return this.$store.getters.getCsvData;
      },
      dropedFile() {
        return this.$store.getters.getDroppedFile;
      },
      studyName() {
        return this.$store.getters.getStudyName;
      }
    },
    methods: {
    addFile(e) {
      let files = e.dataTransfer.files;

      if (!files.length) return;
      this.createInput(files[0]);
      this.selectedDataset = "";
      this.$store.dispatch("changeForwardState", false);
    },
    addFilebyClick(e) {
      let files = e.target.files;
      this.selectedDataset = "";

      if (!files.length) return;
      this.createInput(files[0]);
      this.$store.dispatch("changeForwardState", false);
    },
    createInput(file) {
      let reader = new FileReader();
      this.$store.dispatch("changeCsvData", []);

      let vm = this;
      reader.onload = e => {
        const csvData = reader.result.split("\n");
        vm.fileInput = reader.result;
        vm.$store.dispatch("changeCsvHeaders", csvData[0].split(","));

        let extention = file.name.split(".")[1];
        let httpCheck = csvData[1]
          .split(",")
          .filter(item => item.includes("http"));
        let httpColumnIndex = csvData[1].split(",").indexOf(httpCheck[0]);

        if (extention !== "csv") {
          vm.$store.dispatch("setCsvError", "Wrong file extention");
          vm.$store.dispatch("changeForwardState", true);
        } else if (httpCheck.length == 0) {
          vm.$store.dispatch("setCsvError", "You dont have proper image urls in your csv file");
          vm.$store.dispatch("changeForwardState", true);
        } else {
          // check this afterwards
          let csvHeadersCopy = [...vm.csvHeaders];
          let csvDataCopy = [...vm.csvData];

          let change = csvHeadersCopy[0];
          csvHeadersCopy[0] = csvHeadersCopy[httpColumnIndex];
          csvHeadersCopy[httpColumnIndex] = change;

          for (let i = 1; i < csvData.length - 1; i++) {
            let column = [];

            for (let j = 0; j < csvHeadersCopy.length; j++) {
              let entry = csvData[i].split(",")[j];
              if (j === 0) {
                entry = csvData[i].split(",")[j + httpColumnIndex];
              }
              if (j === httpColumnIndex) {
                entry = csvData[i].split(",")[j - httpColumnIndex];
              }

              column.push(entry);
            }

            csvDataCopy.push(column);
          }

          vm.$store.dispatch("changeCsvData", csvDataCopy);
          vm.$store.dispatch("setCsvError", "");
          vm.$store.dispatch("changeDroppedFile", file);
          vm.$store.dispatch("changeForwardState", false);
        }
      };
      reader.readAsText(file);
    },
    onStudyNameChange(e){
      this.$store.dispatch("changeStudyName", e.target.value);
    },
    changeDataset(value) {
      this.$store.dispatch("setCsvError", "");
      if (this.selectedDataset == 1) {
        this.$store.dispatch("changeDroppedFile", {
          name: "nih-chest.csv",
          file:
            "https://storage.cloud.google.com/saliency-storage/examples/nih-chest-500-example.csv",
          type: "url"
        });
        this.$store.dispatch("changeStudyName", "nih-chest");

        axios.get("./csvFiles/nih-chest-500.csv").then(res => {
          let csvMock = res.data.split("\n");
          this.$store.dispatch("changeCsvHeaders", csvMock[0].split(","));
          this.$store.dispatch("changeCsvData", []);

          //Check this as well
          let csvDataCopy = [...this.csvData]
          var num_rows = Math.min(csvMock.length, 6);

          for (let i = 1; i < num_rows; i++) {
            let row = [];
            for (let j = 0; j < this.csvHeaders.length; j++) {
              let entry = csvMock[i].split(",")[j];

              row.push(entry);
            }
            csvDataCopy.push(row);
          }

          this.$store.dispatch("changeCsvData", csvDataCopy);
        });
      }
      this.$store.dispatch("changeForwardState", false);
    },
  },
  }
</script>
<style lang="scss" scoped>
.step-one {
  &__header {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  &__flex {
    display: flex;
  }

  &__half {
    width: 50%;
  }

  &__select {
    width: 90%;
    padding: 5px 0;
    border-radius: 5px;
    font-size: 18px;
    color: #817676;

    &:focus {
      outline: none;
    }
  }

  &__custom-input {
    display: none;
  }

  &__drag {
    width: 220px;
    height: 98px;
    border: 3px dashed #aaaaaa;
    border-radius: 10px;
    text-align: center;
    margin: 0 auto 10px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &--error {
      width: 220px;
      height: 98px;
      border: 3px dashed #aaaaaa;
      border-radius: 10px;
      text-align: center;
      margin: 0 auto 10px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: red;
    }
  }

  &__nameInput {
    border: 1px solid #aaaaaa;
    width: 220px;
    margin: 0 auto;
  }

  &__nameText {
    width: 220px;
    margin: 0 auto 10px;
  }
}
</style>
